var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zoomsliderbase"},[_c('div',{ref:"zoomslider",staticClass:"zslidermain",attrs:{"height":"300px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }